var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-textarea',_vm._g(_vm._b({ref:"textarea",class:{ required: _vm.required },style:({ height: _vm.textareaHeight }),attrs:{"dense":"","value":_vm.value,"required":_vm.required,"validate-on-blur":"","rows":"1","auto-grow":""},on:{"input":_vm.updateTextareaHeight}},'v-textarea',[_vm.$props, _vm.$attrs],false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }